import { render } from "./FridgeCoolingAssistSettingsPage.vue?vue&type=template&id=6a9a9ffe&scoped=true&ts=true"
import script from "./FridgeCoolingAssistSettingsPage.vue?vue&type=script&lang=ts"
export * from "./FridgeCoolingAssistSettingsPage.vue?vue&type=script&lang=ts"

import "./FridgeCoolingAssistSettingsPage.vue?vue&type=style&index=0&id=6a9a9ffe&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9a9ffe"]])

export default __exports__